module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_error-ac6858b39e9c45037974922736e34fbe.svg";